export enum Period {
  AM = 1,
  PM = 2,
}

export const getHours = (date?: Date): number | null => {
  if (!date) {
    return null;
  }
  const hours24 = date.getHours();
  if (hours24 === 0) return 12;
  return hours24 > 12 ? hours24 - 12 : hours24;
};

export const getMinutes = (date?: Date): number | null =>
  date ? date.getMinutes() : null;

export const getPeriod = (date?: Date): Period | null => {
  if (!date) {
    return null;
  }
  return date.getHours() < 12 ? Period.AM : Period.PM;
};
